import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ApiService } from './api.service';
import { AuthService } from './auth.service';

export type AddonCode = 'PRODUCTION_STORAGE' | 'RETAIL_BOOTH' | 'COLLECTION_POINT';
export interface AddonLicence {
  quantity: number;
  used: number;
  valid_from: string | null;
  valid_until: string | null;
  active: boolean;
  released: boolean;
}
export interface DairyAddons {
  dairy_id: number;
  dairy_name: string;
  premium_active: boolean;
  renewal_date: string;
  modules: Record<AddonCode, AddonLicence>;
}

@Injectable({ providedIn: 'root' })
export class DairyAddonService {
  private status?: DairyAddons;
  error = '';

  constructor(private api: ApiService, private auth: AuthService) {}

  refresh(): Observable<{ addons: DairyAddons }> {
    const dairyId = this.auth.getDairyId();
    this.error = '';
    return this.api.get<{ addons: DairyAddons }>(`store/addons.php?dairy_id=${dairyId}`).pipe(
      tap({
        next: response => {
          if (this.auth.getDairyId() === dairyId) this.status = response.addons;
        },
        error: () => {
          if (this.auth.getDairyId() !== dairyId) return;
          this.status = undefined;
          this.error = 'Unable to verify dairy add-ons. Retry or open Milkomatic Store.';
        }
      })
    );
  }

  active(code: AddonCode): boolean {
    const licence = this.status?.dairy_id === this.auth.getDairyId() ? this.status.modules[code] : undefined;
    const today = new Date();
    const date = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    return !!licence?.active && !!licence.valid_until && licence.valid_until >= date;
  }
}
